// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import TextField from '@/modules/common/components/TextField';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';

const initialValues = {
    code: '',
    name: '',
};

const initialErrors = {
    code: '',
    name: '',
};

let abortController;

const DialogAdd = (props) => {
    const offerName = props.match.params.offerName;

    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.post(`/api/types/`, {offer_name: offerName, ...values}, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    clear();
                    props.onOk(data);
                }
                else {
                    let _errors = {...initialErrors};
                    _errors.code = (data.code) ? data.code[0] : '';
                    _errors.name = (data.name) ? data.name[0] : '';
                    setErrors({..._errors});
                }
                setFetching(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setFetching(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
    };

    return (
        <DialogForm title="Добавление типа" label="Добавить"
                    open={props.open} onSubmit={handleSubmit} onClose={handleClose}
                    disabled={fetching}
        >
            <>
                <TextField label="Код"
                           value={values.code} onChange={handleChange('code')}
                           error={errors.code.length > 0}
                           helperText={errors.code}
                           onFocus={handleFocus('code')}
                           autoFocus={true}
                />
                <TextField label="Название"
                           value={values.name} onChange={handleChange('name')}
                           error={errors.name.length > 0}
                           helperText={errors.name}
                           onFocus={handleFocus('name')}
                />
            </>
        </DialogForm>
    );
};

DialogAdd.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogAdd;
Component = withRouter(Component);
Component = withFetch(Component);

export default Component;
